<template>
    <div class="maintitle">
        <div class="title-tool-wrap">
            <div class="title-tool-bar">
                <el-button size="small" icon="el-icon-document-add" @click="doPaste">粘贴</el-button>
                <el-button size="small" icon="el-icon-document-copy" @click="doCopy">复制</el-button>
                <el-button size="small" icon="el-icon-delete" @click="doClear">清空</el-button>
                <el-button type="primary" size="small" icon="el-icon-s-promotion" :loading="formatLoading" @click="submitToDeepseek" class="btn-submit">
                    {{ submitButtonText }}
                </el-button>
            </div>
            <div class="title-tool-textarea-wrap">
                <el-input
                    ref="mainInput"
                    v-model="txtdata"
                    type="textarea"
                    :autosize="{ minRows: 10, maxRows: 28 }"
                    :placeholder="inputPlaceholder"
                />
                <div v-if="formatLoading" class="title-tool-loading">
                    <i class="el-icon-loading title-tool-spinner"></i>
                    <p class="title-tool-loading-text">正在智能整理中，请稍候...</p>
                </div>
            </div>
            <p class="title-tool-info">共 {{ linenums }} 行，{{ titlenums }} 个题目</p>
        </div>
        <!-- <div class="titles">
            <SingleTitle v-for="title in titles " :key="title.id" :timu="title.title" :options="title.options"
                :xuhao="title.num" :answer="title.answer" />
        </div> -->
    </div>
</template>

<script>
import { nanoid } from "nanoid"
import SingleTitle from './title.vue';
export default {
 name: 'TitleTool',
 components: {
     SingleTitle
 },
 data() {
     return {
        systemPrompt: `你是一个专业的题目智能格式化助手。请分析用户提供的题目，自动识别题目类型并整理成标准格式。

【核心要求】
1. 每道题目必须独立完整，题目之间用空行分隔
2. 严格按照指定格式输出，不要有多余的内容
3. 保持原意不变

【题目类型识别与格式】
1. 判断题 → 格式：序号.[判断]题目内容
   答案：正确 或 答案：错误

2. 填空题 → 格式：序号.[填空]题目内容
   答案：填空内容
   填空处的留空必须用括号（ ），禁止使用下划线

3. 单选题 → 格式：序号.[单选]题目内容
   A.选项内容
   B.选项内容
   C.选项内容
   D.选项内容
   答案：A (或其他正确选项字母)

4. 多选题 → 格式：序号.[多选]题目内容
   A.选项内容
   B.选项内容
   C.选项内容
   D.选项内容
   答案：AB (或多个正确选项字母)

5. 简答题 → 格式：序号.[简答]题目内容
   答案：详细解答内容

【输出格式规则】
1. 每道题目必须从新行开始
2. 题目和答案之间换行
3. 选择题选项每个占一行
4. 每道题目结束后必须有一个空行
5. 所有答案行都以"答案："开头
6. 序号从1开始连续编号
7. 输出的文本要显示在Winform的text文本框中，确保输出格式的换行符可以正常显示

【严禁出现的错误】
1. 严禁题目连在一起：如"答案：B.2.[判断]"
2. 严禁缺少换行：如选项在同一行"A.选项 B.选项"
3. 严禁格式不一致

【完美输出示例】
1.[判断]新中国是1949年成立的。
答案：正确

2.[填空]新中国是（ ）年成立的。（填空处用括号，不用下划线）
答案：1949

3.[单选]新中国是哪年成立的？
A.1946年
B.1949年
C.1950年
D.1951年
答案：B

4.[多选]下列哪些是编程语言？
A.Python
B.Java
C.Word
D.C++
答案：ABD

5.[简答]简述面向对象编程的特点。
答案：面向对象编程有三大特点：封装、继承、多态。封装是指...

记住：格式要严格、清晰、一致！`,
         txtdata: "",
         formatLoading: false,
     };
 },

 computed: {
     titles: {
         get() {
             var strs = this.txtdata.split("\n")
             var reg_title = new RegExp('^[0-9]+[、.,,．、]?', "g");//匹配的是题干开始的位置
             var reg_option = new RegExp("[ABCDEFGH][、.．;:]"); //创建正则RegExp对象,匹配的是选项开始的位置         //  
             var reg_answer = new RegExp("^(答案|答|正确答案)[:：]?"); //创建正则RegExp对象,匹配的是选项开始的位置    
             var titles = []
             var title
             var options = []
             var answer
             var xuhao = 0
             console.log(strs.length, '这个题目是：', title)
             for (var num = 0; num < strs.length; num++) {
                 if (reg_title.test(strs[num])) {

                     xuhao += 1;
                     titles.push({ id: nanoid(), num: xuhao, title, options, answer })
                     titles[titles.length - 1].title = strs[num] = strs[num].replace(reg_title, "");
                     titles[titles.length - 1].options = []
                     titles[titles.length - 1].answer = ""
                 }
                 if (reg_option.test(strs[num])) {
                     titles[titles.length - 1].options.push(strs[num].replace(reg_option, ""))
                 }
                 if (reg_answer.test(strs[num])) {
                     titles[titles.length - 1].answer = strs[num].replace(reg_answer, "");
                 }
             }
             console.log(titles)
             return titles
         }
     },
     linenums: {
         get() {
             return this.txtdata.split("\n").length
         }
     },
     titlenums: {
         get() {
             let strs = this.txtdata.split("\n")
             var reg = new RegExp('^[0-9]+[、.,,．、]?', "g");//匹配的是题干开始的位置
             let a = 0
             for (var num = 0; num < strs.length; num++) {
                 if (reg.test(strs[num])) a++
             }
             return a
         }
     },
     // 提交 DeepSeek 所需金币：500 字 1 金币，不足 500 按 500 算
     deepseekCoins() {
         const len = (this.txtdata || '').trim().length
         if (len === 0) return 0
         return Math.max(1, Math.ceil(len / 500))
     },
     coinChargeEnabled() {
         return this.$store.state.coinChargeEnabled !== false
     },
     submitButtonText() {
         if (!this.coinChargeEnabled) return '提交 DeepSeek（当前免费）'
         return `提交 DeepSeek（约 ${this.deepseekCoins} 金币）`
     },
     inputPlaceholder() {
         if (!this.coinChargeEnabled) {
             return '在此输入或粘贴题目/文字，点击「提交 DeepSeek」由 AI 按规则整理。当前为限时免费模式，登录后不扣金币。'
         }
         return '在此输入或粘贴题目/文字，点击「提交 DeepSeek」由 AI 按规则整理。每 500 字消耗 1 金币，不足 500 按 500 算。'
     }
 },
 methods: {
    doPaste() {
        if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.readText) {
            navigator.clipboard.readText().then((t) => { this.txtdata = (this.txtdata || '') + t; }).catch(() => this.$message.warning('无法读取剪贴板，请手动粘贴'));
        } else {
            this.$message.info('请使用 Ctrl+V 在框内粘贴');
        }
    },
    doCopy() {
        const t = (this.txtdata || '').trim();
        if (!t) { this.$message.warning('暂无内容可复制'); return; }
        if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(t).then(() => this.$message.success('已复制到剪贴板')).catch(() => this.$message.warning('复制失败'));
        } else {
            this.$message.info('请选中框内文字后 Ctrl+C 复制');
        }
    },
    doClear() {
        this.$confirm('确定清空全部内容？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => { this.txtdata = ''; this.$message.success('已清空'); }).catch(() => {});
    },
    submitToDeepseek() {
        const text = (this.txtdata || '').trim();
        if (!text) {
            this.$message.warning('请先输入或粘贴题目内容');
            return;
        }
        const user = this.$store.state.user;
        if (!user || !user.token) {
            this.$message.warning('请先登录后再使用 DeepSeek 整理');
            this.$store.commit('SetShowLoginDialog', { show: true });
            return;
        }
        const coinsNeed = Math.max(1, Math.ceil(text.length / 500));
        const coinsHave = (user.coins != null) ? user.coins : 0;
        if (this.coinChargeEnabled && coinsHave < coinsNeed) {
            this.$message.warning(`需要 ${coinsNeed} 金币，当前仅 ${coinsHave} 金币，请先购买或赚取金币`);
            this.$store.commit('SetOpenPayDialog', true);
            return;
        }
        this.formatLoading = true;
        const token = user.token;
        this.$axios.post('/user/coin/log', { token, type: 'spend', amount: coinsNeed, remark: 'DeepSeek题目整理' })
            .then((logRes) => {
                if (logRes.data && logRes.data.coins != null) this.$store.commit('SetUserCoins', logRes.data.coins);
                return this.$axios.post('/title/format', { text });
            })
            .then((res) => {
                if (res.data && res.data.success && res.data.result) {
                    this.txtdata = res.data.result;
                    this.$message.success('DeepSeek 整理完成');
                } else {
                    this.$message.warning(res.data && res.data.message ? res.data.message : '整理失败');
                }
            })
            .catch((err) => {
                const msg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : '请求失败，请检查网络或联系管理员';
                this.$message.error(msg);
            })
            .finally(() => { this.formatLoading = false; });
    },
 }
}
</script>

<style scoped lang="less">
.maintitle {
    padding: 12px 0;
    box-sizing: border-box;
}
.title-tool-wrap {
    max-width: 900px;
    margin: 0 auto;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0,0,0,.08);
    padding: 16px;
    position: relative;
    box-sizing: border-box;
}
.title-tool-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
}
.title-tool-bar .el-button { margin: 0; }
.title-tool-bar .btn-submit { margin-left: auto; }
.title-tool-textarea-wrap {
    position: relative;
    margin-bottom: 8px;
}
.title-tool-textarea-wrap ::v-deep .el-textarea__inner {
    font-size: 14px;
    line-height: 1.6;
    border-radius: 6px;
    box-sizing: border-box;
}
.title-tool-loading {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(255,255,255,.92);
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 10;
}
.title-tool-spinner {
    font-size: 42px;
    color: #409EFF;
    margin-bottom: 12px;
}
.title-tool-loading-text {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
}
.title-tool-info {
    margin: 0;
    font-size: 12px;
    color: #909399;
}

/* 移动端 */
@media (max-width: 768px) {
    .maintitle {
        padding: 8px 0;
        width: 100%;
        overflow-x: hidden;
    }
    .title-tool-wrap {
        width: 100%;
        max-width: 100%;
        margin: 0;
        padding: 12px 10px 16px;
        border-radius: 6px;
        box-sizing: border-box;
    }
    .title-tool-bar {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 10px;
    }
    .title-tool-bar .el-button {
        flex: 1;
        min-width: 0;
        margin: 0;
        padding: 8px 6px;
        font-size: 13px;
    }
    .title-tool-bar .el-button span { font-size: 13px; }
    .title-tool-bar .btn-submit {
        flex: 1 1 100%;
        margin-left: 0;
        margin-top: 4px;
        width: 100%;
        padding: 10px 12px;
    }
    .title-tool-textarea-wrap {
        margin-bottom: 6px;
        width: 100%;
        box-sizing: border-box;
    }
    .title-tool-textarea-wrap ::v-deep .el-textarea__inner {
        width: 100% !important;
        min-height: 180px;
        padding: 10px;
        font-size: 15px;
        box-sizing: border-box;
    }
    .title-tool-loading-text { font-size: 15px; }
    .title-tool-spinner { font-size: 36px; }
    .title-tool-info { font-size: 12px; }
}
</style>

<!-- 暗黑模式适配 -->
<style lang="less">
.dark-mode .title-tool-wrap {
    background: var(--bg-card) !important;
    box-shadow: 0 1px 4px var(--shadow-color) !important;
}
.dark-mode .title-tool-loading {
    background: rgba(30, 42, 58, 0.92) !important;
}
.dark-mode .title-tool-loading-text {
    color: var(--text-primary) !important;
}
.dark-mode .title-tool-info {
    color: var(--text-secondary) !important;
}
</style>
